// Dev-only mock config — defines the target shape for the lead dev to hook up via componentStore
export default {
    psp: 'vol',
    headerCId: null, // set to a component cId string to override the default header
    header: {
        headline: { field: 'VOL_FULL_NAME' },
        monogram: [
            { field: 'VOL_FIRST_NAME' },
            { field: 'VOL_LAST_NAME' },
        ],
        meta: [
            { field: 'VOLUNTEER_ID', icon: 'fa-solid fa-id-card' },
            { field: 'ORG_NAME', icon: 'fa-solid fa-building' },
            { field: 'VOL_FULL_CITY_ADDRESS', icon: 'fa-solid fa-location-dot' },
        ],
        badges: [
            { field: 'VOL_ACTIVITY_STATUS', label: 'Active', type: 'active' },
            { field: 'CUSTOM_ATTRIBUTE#1505400', label: 'Application', type: 'cleared' },
        ],
    },
    tabs: [
        {
            id: 'VP_PERSONAL',
            label: 'Personal',
            icon: 'user',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_ADDITIONA',
            label: 'Additional',
            icon: 'fa-solid fa-plus',
            isFullPage: true,
            cards: [
                {
                    id: 'card_additional_fields',
                    title: 'Additional Fields',
                    type: 'component',
                    component: 'customFields',
                    position: {
                        row: 0, col: 0, sizeX: 5, sizeY: 4
                    }
                }
            ]
        },
        {
            id: 'VP_CUSTOM',
            label: 'User Defined',
            icon: 'fa-regular fa-sharp fa-cabinet-filing',
            isFullPage: true,
            cards: [
                {
                    id: 'card_user_defined_fields',
                    title: 'User Defined Fields',
                    type: 'component',
                    component: 'userDefinedFieldsViewer',
                    position: {
                        row: 0, col: 0, sizeX: 5, sizeY: 4
                    }
                }
            ]
        },
        {
            id: 'VP_SKILLS',
            label: 'Skills',
            icon: 'fa-solid fa-star',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_AVAIL',
            label: 'Availability',
            icon: 'fa-solid fa-calendar',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_BACKGRCHECK',
            label: 'Background Check',
            icon: 'shield',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_REFERENCES',
            label: 'References',
            icon: 'fa-solid fa-address-book',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_AUTHFIELD',
            label: 'Authorizations',
            icon: 'fa-solid fa-file-signature',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_HISTORY',
            label: 'History',
            icon: 'history',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_ATTACH',
            label: 'Attachments',
            icon: 'paperclip',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_PROFESSION',
            label: 'Professions',
            icon: 'fa-solid fa-briefcase',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_LANGUAGE',
            label: 'Language',
            icon: 'fa-solid fa-language',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_ACTIVITY_STATUS_MODIFY',
            label: 'Personal/Modify Activity Status button',
            icon: 'fa-solid fa-toggle-on',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_VOL_COMPLIANCE_STATUS_MODIFY',
            label: 'Modify Compliance Status button',
            icon: 'fa-solid fa-toggle-on',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_WAIVER',
            label: 'Waivers',
            icon: 'fa-solid fa-file-contract',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_TRAININGS',
            label: 'Trainings',
            icon: 'fa-solid fa-graduation-cap',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_LOGBOOK',
            label: 'Log Book',
            icon: 'book',
            isFullPage: true,
            cards: []
        },
        {
            id: 'VP_WORKFLOW',
            label: 'Workflow',
            icon: 'clipboard',
            isFullPage: true,
            cards: []
        }
    ]
};
